// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__dsZt6","load7":"Spinner_load7__3E-2d"};